/*! data-type: share-on-facebook, share-on-twitter, share-on-xing, share-by-whatsapp, share-by-email, share-native */
(function() {
  'use strict';
  // polyfill matches old browser
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.msMatchesSelector ||
      Element.prototype.webkitMatchesSelector;
  }

  let facebook = document.querySelectorAll("[data-type='share-on-facebook']");
  for (let i = 0; i < facebook.length; i++) {
    if (facebook[i].tagName.toLowerCase() === 'a') {
      facebook[i].setAttribute('href', 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href) + '&title=' + encodeURIComponent(document.title));
    } else {
      // old span
      facebook[i].setAttribute('tabindex', '0');
      facebook[i].addEventListener('click', function () {
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href) + '&title=' + encodeURIComponent(document.title));
      });
    }
  }
  let twitter = document.querySelectorAll("[data-type='share-on-twitter']");
  for (let i = 0; i < twitter.length; i++) {
    if (twitter[i].tagName.toLowerCase() === 'a') {
      twitter[i].setAttribute('href', 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(location.href) + '&title=' + encodeURIComponent(document.title));
    } else {
      // old span
      twitter[i].setAttribute('tabindex', '0');
      twitter[i].addEventListener('click', function () {
        window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(location.href) + '&title=' + encodeURIComponent(document.title));
      });
    }
  }
  let xing = document.querySelectorAll("[data-type='share-on-xing']");
  for (let i = 0; i < xing.length; i++) {
    if (xing[i].tagName.toLowerCase() === 'a') {
      xing[i].setAttribute('href', 'https://www.xing.com/spi/shares/new?url=' + encodeURIComponent(location.href) + '&title=' + encodeURIComponent(document.title));
    } else {
      // old span
      xing[i].setAttribute('tabindex', '0');
      xing[i].addEventListener('click', function () {
        window.open('https://www.xing.com/spi/shares/new?url=' + encodeURIComponent(location.href) + '&title=' + encodeURIComponent(document.title));
      });
    }
  }
  let linkedin = document.querySelectorAll("[data-type='share-on-linkedin']");
  for (let i = 0; i < linkedin.length; i++) {
    if (linkedin[i].tagName.toLowerCase() === 'a') {
      linkedin[i].setAttribute('href', 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(location.href));
    }
  }
  let whatsapp = document.querySelectorAll("[data-type='share-by-whatsapp']");
  for (let i = 0; i < whatsapp.length; i++) {
    if (whatsapp[i].tagName.toLowerCase() === 'a') {
      whatsapp[i].setAttribute('href', 'https://api.whatsapp.com/send?text='+encodeURIComponent(location.href));
    } else {
      // old span
      whatsapp[i].setAttribute('tabindex', '0');
      whatsapp[i].addEventListener('click', function () {
        window.open('https://wa.me/?text=' + encodeURIComponent(location.href));
      });
    }
  }
  let email = document.querySelectorAll("[data-type='share-by-email']");
  for (let i = 0; i < email.length; i++) {
    if (email[i].tagName.toLowerCase() === 'a') {
      email[i].href = 'mailto:?subject=' + document.title.slice(0, 77) + '&body=' + escape(location.href);
    } else {
      // old span
      email[i].setAttribute('tabindex', '0');
      email[i].addEventListener('click', function () {
        location.href = 'mailto:?subject=' + document.title.slice(0, 77) + '&body=' + escape(location.href);
      });
    }
  }
  let emailShareing = document.querySelectorAll("a[data-type='share-by-mail']");
  for (let i = 0; i < emailShareing.length; i++) {
    let subject = encodeURIComponent(emailShareing[i].dataset.subject.replaceAll("\\n","\n") + document.title);
    let body = encodeURIComponent(emailShareing[i].dataset.pre.replaceAll("\\n","\n") + "\n" + window.location.href + "\n" + emailShareing[i].dataset.post.replaceAll("\\n","\n"));
    emailShareing[i].setAttribute('href', "mailto:?subject=" + subject + "&body=" + body);
  }
  let nativeShare = document.querySelectorAll("[data-type='share-native']");
  for (let i = 0; i < nativeShare.length; i++) {
    if (navigator.share) {
      let shareTitle = nativeShare[i].dataset.title;
      if (!shareTitle) {
        shareTitle = document.title;
      }
      let shareText = nativeShare[i].dataset.text;
      if (!shareText) {
        let desc = document.head.querySelector("[name=description][content]");
        if (desc) {
          shareText = desc.content;
        } else {
          shareText = '';
        }
      }
      nativeShare[i].addEventListener('click', function () {
        navigator.share({title: shareTitle, text: shareText, url: location.href});
      });
    } else {
      nativeShare[i].classList.add('hidden');
    }
  }

  if (document.querySelector("span[data-type*='share-']")) {
    // accessibility: handle tabindex enter keydown event
    document.addEventListener('keydown', function(event) {
      if (event.key === "Enter") {
        if (event.target.matches("span[data-type*='share-']")) {
          event.target.click();
        }
      }
    });
  }
})();
